<template>
  <div class="news-organization-detail">
    <app-header />
    <main>
      <div class="container-fluid">
        <div class="d-flex">
          <div class="image-wrapper">
            <div v-if="organization.organize_logo"
                 class="logo-image-cover">
                <img class="logo-image" :src="organization.organize_logo">
            </div>

            <div v-if="!organization.organize_logo"
                 class="image"
                 :style="{ backgroundImage: `url('/static/img/common/organization-placeholder.jpg')` }"></div>

          </div>
          <div class="title-wrapper">
            <h1 class="title">{{ organization.name }}</h1>
            <button
              :class="{ 'btn-border-dark': organization.follow, 'btn-news': !organization.follow }"
              class="btn btn-round btn-block shadow-bottom"
              @click="toggleFollow(organization.id)">
              <template v-if="!organization.follow">
                <span>ติดตาม</span>
              </template>
              <template v-if="organization.follow">
                <span>ติดตามแล้ว</span>
              </template>
            </button>
          </div>
        </div>

        <div class="organization-contact">
          <h6>ข้อมูลติดต่อ</h6>
          <p>
            <span class="text-news">โทรศัพท์ : </span>
          {{ organization.phone || '-' }}
          </p>
          <p>
            <span class="text-news">โทรสาร : </span>
            {{ organization.fax || '-' }}
          </p>
          <p>
            <span class="text-news">อีเมล : </span>
            {{ organization.email || '-' }}
          </p>
          <p >
            <span class="text-news">เวลาทำการ : </span>
            {{ organization.office_hours || '-' }}
          </p>
          <p >
            <span class="text-news">facebook : </span>
            {{ organization.facebook_url || '-' }}
          </p>
          <p >
            <span class="text-news">website : </span>
            {{ organization.website_url || '-' }}
          </p>
          <p class="mb-1">
            <span class="text-news">line : </span>
            {{ organization.line_url || '-' }}
          </p>
          <p>
          <span class="text-news">
            <fa-icon icon="map-marker-alt"></fa-icon>
            ที่อยู่ :
          </span>
            {{ organization.address || '-' }}
          </p>
        </div>
      </div>

      <hr>

      <div class="container-fluid">
        <h2 class="organization-news">ข่าวสารทั้งหมด</h2>
      </div>
      <news-list :news-list="newsList" />

    </main>
    <app-footer />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { EventBus } from '../utils/EventBus.js'
  import moment from 'moment'
  import AppHeader from '../components/Header.component'
  import AppFooter from '../components/Footer.component'
  import NewsList from '../components/NewsList.component'

  export default {
    name: 'news-organization-detail',
    components: {
      AppHeader,
      AppFooter,
      NewsList
    },
    props: {
      organizationId: {
        type: String,
        default: null
      }
    },

    data () {
      return {
        page: 1
      }
    },

    computed: {
      // Map Vuex state.
      ...mapState({
        organization: state => {
          return state.Organize.organizeDetail
        },
        newsList: state => {
          return state.News.newsListByOrganizationId.map(news => ({
            ...news,
            images: news.images
              ? JSON.parse(news.images).map(image => encodeURI(image))
              : [],
            published_at: moment(news.published_at).locale('th').fromNow()
          }))
        }
      })
    },

    created () {
      // Listen to scroll to end event.
      EventBus.$on('scroll-to-end', this.appendNewsListByOrganizationId)

      return this.$store.dispatch(`Organize/getOrganizeDetail`, this.organizationId)
        .then(() => this.$store.dispatch(`News/getNewsListByOrganizationId`, {
          organizationId: this.organizationId,
          page: this.page
        }))
    },

    destroyed () {
      EventBus.$off('scroll-to-end', this.appendNewsListByOrganizationId)
    },

    methods: {
      appendNewsListByOrganizationId () {
        this.page++
        return this.$store.dispatch(`News/getNewsListByOrganizationId`, {
          organizationId: this.organizationId,
          page: this.page
        })
      },
      toggleFollow (organizeId) {
        return this.$store.dispatch(`Organize/followOrganization`, organizeId)
          .then(() => this.$store.dispatch(`Organize/getOrganizeDetail`, this.organizationId))
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/styles";

  .logo-image{
    height: 100%;
    display:block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    border-radius: 50%;
  }

  .logo-image-cover{
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    height: 100%;
    border-radius: 50%;
  }

  main {
    margin-top: $header-height;
    padding-top: 15px;
    .image-wrapper {
      border: 2px solid #DADADA;
      box-sizing: border-box;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
      border-radius: 50%;
      padding: 2px;
      width: 85px;
      height: 85px;
      flex: none;
      .image {
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        height: 100%;
        border-radius: 50%;
      }
    }
    .title-wrapper {
      @extend .flex-grow-1;
      padding: 15px 0 0 20px;
      .title {
        font-size: 20px;
        color: $text-color;
        margin-bottom: 20px;
      }
      button {
        height: 40px;
        margin-bottom: 20px;
      }
    }
    .organization-contact {
      margin-bottom: 30px;
      h6, p {
        margin-bottom: 0;
      }
    }
    .organization-news {
      font-size: 18px;
    }

    .back-to-top {
      @extend .position-fixed;
      @extend .cursor-pointer;
      right: 20px;
      bottom: 40px;
      img {
        width: 34px;
        height: 34px;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/NewsOrganizationDetail.page.vue